import { getStoredPermissions, storedSessionHasPermission } from '../Util/secureStorageSession';

const PermissionCheck = (PermissionType: string): boolean =>
	storedSessionHasPermission(getStoredPermissions(), PermissionType);

export default PermissionCheck;
